<template>
    <modal-content @close="$emit('close')">
        <floor-form ref="form" @o3-submit="onSubmit($event)"/>
    </modal-content>
</template>

<script>
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';
import FloorForm from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/Floor/FloorForm';

export default {
    name:       'UpdateFloorDialog',
    components: {FloorForm, ModalContent},
    props:      {
        floorId: {
            type:     String,
            required: true,
        }
    },
    data() {
        return {
            floor: null
        }
    },
    mounted() {
        this.$store.getters['projects/project/floorPlan/loadFloorById'](this.floorId)
            .then((values) => {
                if (values) {
                    this.floor = values;
                    this.$refs.form.setValues(values);
                }
            });
    },
    methods:    {
        onSubmit(data) {
            const {id} = this.floor;
            this.$store.dispatch('projects/project/floorPlan/updateFloor', {...data, id})
                .then(() => this.$emit('close'))
                .catch((message) => this.$dmv.notifyError(message));
        }
    }
}
</script>
